/* Memore v5j: live total next to Add to cart = selected variant price + any Teeinblue add-on prices readable from the form.
   v5j fix: the old version observed the whole form (childList + subtree) and rewrote its own text on every mutation.
   The total sits inside the form, so each write fired the observer again: an endless microtask loop that froze the
   main thread before DOMContentLoaded (Teeinblue never mounted). Now: writes only when the text changes, updates are
   batched to one per animation frame, our own box is ignored, and everything is wrapped in try/catch. */
(function () {
  if (window.__memoreTotal) return; window.__memoreTotal = true;
  function money(c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function addons(form) {
    var sum = 0;
    if (!form) return 0;
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var m = String(el.value || '').match(/\+\s*\$\s*(\d+(?:[.,]\d{1,2})?)/);
      if (m) sum += Math.round(parseFloat(m[1].replace(',', '.')) * 100);
    });
    return sum;
  }
  function setText(el, t) { if (el && t != null && el.textContent !== t) el.textContent = t; }
  function init(box) {
    var map;
    try { map = JSON.parse(box.getAttribute('data-variants') || '{}'); } catch (e) { return; }
    var scope = box.closest('product-form-component, .product-details, form') || document;
    var form = box.closest('form') || scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var out = box.querySelector('[data-memore-total-value]');
    var n = box.querySelector('[data-memore-ed-name]'), dsc = box.querySelector('[data-memore-ed-desc]');
    var en = box.querySelector('[data-memore-ed-edn]'), sz = box.querySelector('[data-memore-ed-size]'), fr = box.querySelector('[data-memore-ed-frame]');
    function update() {
      try {
        var idEl = form && form.querySelector('[name="id"]');
        var id = idEl ? idEl.value : new URLSearchParams(location.search).get('variant');
        var v = map[id];
        if (v == null) return;
        setText(out, money(v.p + addons(form)));
        if (v.n) setText(n, v.n);
        if (v.d) setText(dsc, v.d);
        if (v.e) setText(en, v.e);
        if (v.s) setText(sz, v.s);
        if (v.f) setText(fr, v.f);
      } catch (e) {}
    }
    var queued = false;
    function schedule() {
      if (queued) return; queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { queued = false; update(); });
    }
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);
    if (form && window.MutationObserver) {
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) { if (!box.contains(recs[i].target)) { schedule(); return; } }
      }).observe(form, { subtree: true, attributes: true, attributeFilter: ['value'], childList: true });
    }
    window.addEventListener('popstate', schedule);
    setInterval(update, 2000); /* catches Horizon setting input.value via JS (no attribute mutation); no-op when unchanged */
    update();
  }
  function run() { try { document.querySelectorAll('[data-memore-total]').forEach(init); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
